"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerBankAdapter__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_correlatedToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_feedAddr",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "exchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feedAddr",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x60803460a357601f61022f38819003918201601f19168301916001600160401b0383118484101760a85780849260609460405283398101031260a35760428160be565b906057604060516020840160be565b920160be565b600180546001600160a01b039485166001600160a01b03199182161790915560008054938516938216939093179092556002805491909316911617905560405161015d90816100d28239f35b600080fd5b634e487b7160e01b600052604160045260246000fd5b51906001600160a01b038216820360a35756fe608080604052600436101561001357600080fd5b60003560e01c90816307391adb146101035750633ba0b9a91461003557600080fd5b346100fe5760003660031901126100fe5760025460015460405163b95ed06f60e01b81526001600160a01b0391821660048201529160209183916024918391165afa9081156100f257600091610091575b602082604051908152f35b60203d6020116100eb575b601f8101601f1916820167ffffffffffffffff8111838210176100d7576020918391604052810103126100d3575190506020610086565b5080fd5b634e487b7160e01b84526041600452602484fd5b503d61009c565b6040513d6000823e3d90fd5b600080fd5b346100fe5760003660031901126100fe576002546001600160a01b03168152602090f3fea2646970667358221220926b11b089496d6cec2f93bec2e894c20ae431b36d0603d3b6c499f990dc5e8264736f6c634300081a0033";
const isSuperArgs = (xs) => xs.length > 1;
class LayerBankAdapter__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_correlatedToken, _underlyingToken, _feedAddr, overrides) {
        return super.getDeployTransaction(_correlatedToken, _underlyingToken, _feedAddr, overrides || {});
    }
    deploy(_correlatedToken, _underlyingToken, _feedAddr, overrides) {
        return super.deploy(_correlatedToken, _underlyingToken, _feedAddr, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.LayerBankAdapter__factory = LayerBankAdapter__factory;
LayerBankAdapter__factory.bytecode = _bytecode;
LayerBankAdapter__factory.abi = _abi;
//# sourceMappingURL=LayerBankAdapter__factory.js.map